import RequestAbstract from '../abstract';

export default class P2PInstances extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/p2p-instances';
    }
}
